import { useLayoutEffect, useRef } from 'react';

import { SearchFormActions } from './SearchFormStore.js';
import useSearchForm from './useSearchForm.js';

export const useSearchFormSubscribe = (cb: (action: SearchFormActions) => void) => {
  const cbRef = useRef(cb);

  cbRef.current = cb;

  const [, , { subscribe }] = useSearchForm();

  useLayoutEffect(() => {
    return subscribe((action) => {
      cbRef.current(action);
    });
  }, [subscribe]);
};
